import moment from 'moment';
import { useState } from 'react';
import { FormPreviewProps } from './FormPreview.types';
import { ServiceItem } from '../../entities/IMetaData';

export const FormPreview = ({ fields }: FormPreviewProps) => {
	const [expandedFields, setExpandedFields] = useState<Record<number, boolean>>({});
	console.log(fields);

	const toggleFieldExpansion = (index: number) => {
		setExpandedFields((prev) => ({
			...prev,
			[index]: !prev[index],
		}));
	};

	const renderJsonArray = (fieldValue: string, fieldIndex: number) => {
		const items = JSON.parse(fieldValue).map(
			(item: ServiceItem) =>
				`${item.msisdn} - ${item.offerType} - ${item.offerPurpose}`
		);

		const ITEMS_TO_SHOW = 5;
		const hasMoreItems = items.length > ITEMS_TO_SHOW;
		const isExpanded = expandedFields[fieldIndex];
		const displayedItems = hasMoreItems && !isExpanded 
			? items.slice(0, ITEMS_TO_SHOW) 
			: items;

		return (
			<>
				{displayedItems.map((item: string) => (
					<div
						className='mb-2 border rounded p-2 bg-light'
						key={item.toString()}
					>
						{item}
					</div>
				))}
				{hasMoreItems && (
					<button
						type='button'
						className='btn btn-link text-decoration-none p-0 mt-1'
						onClick={() => toggleFieldExpansion(fieldIndex)}
					>
						{isExpanded 
							? `Show less` 
							: `Show ${items.length - ITEMS_TO_SHOW} more item${items.length - ITEMS_TO_SHOW > 1 ? 's' : ''}`
						}
					</button>
				)}
			</>
		);
	};

	return (
		<div className={'flex-column gap-2 w-100'}>
			{fields.map((field, i) => (
				<div
					className={'flex-column'}
					key={i}
					style={{
						padding: '8px 12px',
						borderRadius: 8,
						backgroundColor: '#FFFFFF',
						gap: 0,
						flex: 1,
					}}
				>
					<label className='small' style={{ fontWeight: 'bold' }}>
						{field.label}
					</label>
					<label style={{ wordBreak: 'break-word' }}>
						{field.type === 'date' && field.value
							? moment(field.value).format('DD.MM.YYYY HH:mm')
							: field.type === 'checkbox'
							? field.value
								? 'Yes'
								: 'No'
							: field.type === 'jsonArray' && field.value
							? renderJsonArray(field.value, i)
							: field.value || 'Empty'}
					</label>
				</div>
			))}
		</div>
	);
};
